import React from 'react';
import { Grid, InputLabel, FormHelperText } from '@mui/material';
import moment from 'moment';
import MyTooltip from './MyTooltip';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

interface BirthdayFieldProps {
  control: Control<FieldValues>;
  optionalFields: any;
  /** Dark calendar paper — the picker renders in a portal outside the dark
      Personal information dialog, so the dialog's sx can't reach it. Off in
      the light sign-up wizard. */
  dark?: boolean;
  getError: (name: string) => any;
}

const BirthdayField: React.FC<BirthdayFieldProps> = ({ control, optionalFields, getError, dark = false }) => {
  return (
    <Grid item xs={12} sm={6}>
      <InputLabel>
        Birthday {optionalFields.dob && '*'}
        <MyTooltip title="We capture your birthday so we can mark the occasion with you" placement="right" />
      </InputLabel>
      <Controller
        name="dob"
        control={control}
        render={({ field: { onChange, value } }) => {
          const selectedDate = value ? moment(value, 'MM-DD').toDate() : null;
          const formats = { monthAndYear: 'MMMM' };

          return (
            <LocalizationProvider dateAdapter={AdapterDateFns} dateFormats={formats}>
              <DesktopDatePicker
                format="MM/dd"
                views={['month', 'day']}
                value={selectedDate}
                onChange={(date, value) => {
                  const modifiedDate = date ? moment(date).set('year', 2001).toDate() : null;
                  const selectedValue = date ? moment(modifiedDate).format('MM-DD') : '';
                  onChange(modifiedDate, selectedValue);
                }}
                slotProps={{
                  actionBar: { actions: ['clear'] },
                  // Calendar renders in a portal outside the dark dialog, so
                  // dark-mode it here to match (bg #1C1C1C, orange selection).
                  desktopPaper: {
                    className: 'selectedSectionsClass',
                    sx: dark
                      ? {
                          bgcolor: '#1C1C1C',
                          color: '#FDFDFD',
                          backgroundImage: 'none',
                          border: '1px solid #2A2A2A',
                          '& .MuiPickersCalendarHeader-label': { color: '#FDFDFD' },
                          '& .MuiDayCalendar-weekDayLabel': { color: '#68717A' },
                          '& .MuiPickersDay-root': { color: '#FDFDFD' },
                          '& .MuiPickersDay-root:hover': { bgcolor: '#2A2A2A' },
                          '& .MuiPickersDay-root.Mui-selected': { bgcolor: '#F79420 !important', color: '#0F0F0F' },
                          '& .MuiPickersDay-root.MuiPickersDay-today': { borderColor: '#F79420' },
                          '& .MuiPickersMonth-monthButton': { color: '#FDFDFD' },
                          '& .MuiPickersMonth-monthButton.Mui-selected': {
                            bgcolor: '#F79420 !important',
                            color: '#0F0F0F'
                          },
                          '& .MuiPickersArrowSwitcher-button, & .MuiSvgIcon-root': { color: '#ABB5BE' },
                          '& .MuiButtonBase-root.MuiButton-root': { color: '#F79420' }
                        }
                      : undefined
                  }
                }}
              />
              <FormHelperText error>{getError('dob')?.toString()}</FormHelperText>
            </LocalizationProvider>
          );
        }}
      />
    </Grid>
  );
};

export default BirthdayField;
